<div class="modal-container">
    <div class="flex w-full justify-end">
        <button class="flex justify-center items-center w-10 h-10 rounded-full icon-btn-white" (click)="closeDialog(false)">
            <ng-icon name="tablerX" class="text-2xl"></ng-icon>
        </button>
    </div>
    <div class="flex flex-col w-full space-y-6">
        <app-info [type]="'error'" [title]="errorTitle" [textContent]="errorMessage"></app-info>
        <div class="flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-4">
            <button class="btn-secondary p-5" (click)="closeDialog(false)">
                <h4>
                    {{ 'Cerrar' | translate}}
                </h4>
            </button>
            <button *ngIf="route" class="btn-primary p-5" (click)="closeDialog(true)">
                <h4>
                    {{ 'Volver atrás' | translate}}
                </h4>
            </button>
        </div>
    </div>
</div>